<script setup lang="tsx">
import { getCSSVar } from "@zyzgroup/core-web";

const props = withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {
    color: getCSSVar("--yz-xg-blue", "#5a82f0")
  }
);

const style = {
  borderTopColor: props.color
};
</script>

<template>
  <div class="loading-9">
    <div :style="style"></div>
  </div>
</template>

<style scoped>
.loading-9 {
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.loading-9 div {
  width: 50%;
  aspect-ratio: 1 / 1;
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
